import { useState } from 'react';
import type { LotteryItem } from '@/mocks/gossip';

export default function LotteryCard({ lottery }: { lottery: LotteryItem }) {
  const [joined, setJoined] = useState(false);
  const participants = lottery.participants + (joined ? 1 : 0);

  return (
    <article className="rounded-lg bg-background-50 border border-background-200 p-5 md:p-6 flex flex-col">
      <div className="flex items-start justify-between gap-3">
        <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 text-xl">
          <i className="ri-gift-2-line"></i>
        </span>
        <span className="px-3 py-1 rounded-full bg-accent-100 text-accent-900 text-xs whitespace-nowrap">
          {lottery.highlight}
        </span>
      </div>

      <h3 className="mt-4 font-heading text-xl text-foreground-950">{lottery.title}</h3>
      <p className="mt-1 text-sm text-primary-600">{lottery.prize}</p>
      <p className="mt-3 text-sm text-foreground-600 leading-relaxed flex-1">{lottery.desc}</p>

      <ol className="mt-4 space-y-2">
        {lottery.steps.map((step, index) => (
          <li key={step} className="flex items-center gap-2 text-sm text-foreground-700">
            <span className="w-5 h-5 flex items-center justify-center rounded-full bg-background-200 text-xs text-foreground-700">
              {index + 1}
            </span>
            {step}
          </li>
        ))}
      </ol>

      <div className="mt-5 flex items-center justify-between text-xs text-foreground-500">
        <span className="flex items-center gap-1">
          <i className="ri-user-heart-line"></i>
          {participants.toLocaleString()} 人参与
        </span>
        <span className="flex items-center gap-1">
          <i className="ri-time-line"></i>
          {lottery.endTime}
        </span>
      </div>

      <button
        type="button"
        onClick={() => setJoined((v) => !v)}
        className={`mt-4 w-full py-3 rounded-md text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
          joined
            ? 'bg-secondary-100 text-secondary-900'
            : 'bg-primary-500 text-background-50 hover:bg-primary-600'
        }`}
      >
        {joined ? '已参与 · 点击取消' : '一键参与抽奖'}
      </button>
    </article>
  );
}